import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import { API } from "../../Redux/actions/API";
import { toast } from "react-toastify";

function Zero_Pin_By_5050() {
  const [search, setSearch] = useState("");
  const [value, setActivation] = useState("");

  const referral_API = async () => {
    if (search && value) {
      try {
        let responceRight = await API?.post("/ManageFundbyadmin", {
          uid: search,
          amount: value,
          status: "2",
        });

        console.log("My_Team", responceRight);
        if(responceRight.data.data.result=='SUCCESSFUL')
        {
          toast.success('Fund Deduct Successfully.');
          setActivation("");
          setSearch("");
          setName("");
        }
        else{
          toast(responceRight.data.data.result);
        }
        
       // window.location.reload();
      } catch (e) {
        console.log("Error While calling Myteam API", e);
      }
    } else {
      toast.error("Please Fill All The Fields");
    }
  };
  const [name, setName] = useState("");

  const member_Api = async (value) => {
    try {
      let res = await API.post("/getUserNameForAdmin", {
        uid: value,
      });
      console.log("member_Api", res.data.data.result);
      if (res.data.data.result) {
        setName(res.data.data.result);
      } else {
        setName("");
      }
    } catch (e) {
      console.log("member_Api", e);
    }
  };

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div
          id="content"
          class="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title"> Deduct Funds</h4>
            </div>
            <div
              class="panel-body table-rep-plugin"
              style={{ padding: "8px", overflowY: "scroll" }}
            >
              <div class="row">
                <div class="box col-md-12">
                  <div class="alert alert-block alert-info">
                    <div class="row">
                      <div class="col-md-6 mr-30">
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="popup_net">
                                <span
                                  class="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                <div className="d-flex justify-content-between">
                                  <h1> Deduct Funds</h1>
                                  <a
                                    href="/Funds_Details"
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 10px",
                                      marginTop: "20px",
                                      background: "#0d37a5",
                                      borderRadius: "8px",
                                    }}
                                  >
                                    Funds Details
                                  </a>
                                </div>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>MemberId or Email Id</label>
                                  <input
                                    type="text"
                                  //  inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter MemberId or email id"
                                    value={search}
                                    onChange={(e) => (
                                      setSearch(e.target.value),
                                      member_Api(e.target.value)
                                    )}
                                  />
                                </div>
                                {name && (
                                  <div className="form-group">
                                    <label>Member Name</label>
                                    <input
                                      type="text"
                                      id="txtuid"
                                      class="form-control"
                                      value={name}
                                      readOnly
                                    />
                                  </div>
                                )}

                                <div className="form-group">
                                  <label>Amount</label>
                                  <input
                                    type="number"
                                    inputMode="numeric"
                                    id="txtuid"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    value={value}
                                    onChange={(e) =>
                                      setActivation(e.target.value)
                                    }
                                  />
                                </div>

                                <div class="joinbtn d-flex flex-row-reverse me-auto">
                                  <button
                                    id="btnactive"
                                    style={{
                                      color: "white",
                                      border: "solid 1px #ffff",
                                      padding: "10px 20px",
                                      marginTop: "20px",
                                      borderRadius: "8px",
                                    }}
                                    onClick={() => referral_API()}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Zero_Pin_By_5050;
